<template>
  <v-footer :inset="true" style="justify-content:center; text-align: center" app>
        <span>&copy; d-meeting depa</span>
  </v-footer>
</template>
<script>
export default {
  name: 'FooterView',
}
</script>